import React from "react";
import { useCommonUI } from "../contexts/CommonUIContext";
import { STAT_TYPES } from "../utils/taskListStats";

// Picker for a single stat-card slot, mirroring Android's StatCardWithPicker
// dropdown. Lists the slot's current type plus every type NOT pinned to another
// slot (so a type can't occupy two cards). Each row shows the label + its
// description; the active one is tinted primary with a trailing dot.
const StatPickerDialog = ({ currentKey, usedByOtherKeys = [], onSelect }) => {
  const { closeModal } = useCommonUI();
  const usedSet = new Set(usedByOtherKeys);
  const options = STAT_TYPES.filter(
    (s) => s.key === currentKey || !usedSet.has(s.key)
  );

  const choose = (key) => {
    onSelect(key);
    closeModal();
  };

  return (
    <div style={styles.container}>
      <h3 style={styles.heading}>Choose a stat</h3>
      <div style={styles.list}>
        {options.map((opt) => {
          const selected = opt.key === currentKey;
          return (
            <button
              key={opt.key}
              onClick={() => choose(opt.key)}
              style={{
                ...styles.row,
                ...(selected ? styles.rowSelected : {}),
              }}
            >
              <span style={styles.textCol}>
                <span
                  style={{
                    ...styles.label,
                    color: selected ? "var(--primary)" : "var(--text)",
                  }}
                >
                  {opt.label}
                </span>
                <span style={styles.description}>{opt.description}</span>
              </span>
              {selected && <span style={styles.dot} />}
            </button>
          );
        })}
      </div>
    </div>
  );
};

const styles = {
  container: { minWidth: "260px", maxWidth: "360px" },
  heading: {
    margin: "0 0 12px",
    color: "var(--text)",
    fontSize: "16px",
    fontWeight: "bold",
  },
  list: { display: "flex", flexDirection: "column", gap: "4px" },
  row: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    width: "100%",
    textAlign: "left",
    background: "none",
    border: "none",
    borderRadius: "8px",
    padding: "10px 8px",
    cursor: "pointer",
  },
  rowSelected: { backgroundColor: "var(--surface)" },
  textCol: { display: "flex", flexDirection: "column", gap: "2px", flex: 1, minWidth: 0 },
  label: { fontSize: "15px", fontWeight: 600 },
  description: { fontSize: "12px", color: "var(--text-muted)" },
  dot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    backgroundColor: "var(--primary)",
    flexShrink: 0,
  },
};

export default StatPickerDialog;
